import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteAssetType } from '@api/assetTypes';

import { ESnackbarTypes } from '@enums/common';

import { DELETE_ASSET_TYPE, MANAGE_ASSET_TYPES } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeleteAssetType = (closeModal: () => void) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleDeleteAssetType,
		isLoading: isLoadingDeleteAssetType,
	} = useMutation<string>({
		mutationKey: [DELETE_ASSET_TYPE],
		mutationFn: deleteAssetType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetTypeDeleted,
				type: ESnackbarTypes.success,
			}));

			closeModal();

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
	});

	return {
		handleDeleteAssetType,
		isLoadingDeleteAssetType,
	};
};
